import { useEffect, useState } from 'react';
import { useFeatureFlags } from './useFeatureFlags';

export const MASK_RELEASE_PROCESSING_FLAG = 'mask-release-processing';

// Resolves the global `mask-release-processing` feature flag. When on, the Release
// step shows a "queued" notice instead of the live progress bar / stuck banner —
// used while backend release processing is offline. Release rows are still created
// (status 'pending') and process normally once the backend recovers.
// `loading` lets callers avoid flashing the progress UI before the flag resolves.
export const useMaskReleaseProcessing = (): { masked: boolean; loading: boolean } => {
    const [masked, setMasked] = useState(false);
    const [loading, setLoading] = useState(true);
    const [FeatureFlagFunctions] = useFeatureFlags();

    useEffect(() => {
        let active = true;
        FeatureFlagFunctions.get(MASK_RELEASE_PROCESSING_FLAG).then((value: boolean) => {
            if (!active) return;
            setMasked(value);
            setLoading(false);
        });
        return () => { active = false; };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return { masked, loading };
};
